import {call, put} from 'redux-saga/effects';
import UserActions from '../redux/UserRedux';
import UsersActions from '../redux/UsersRedux';
import MessagesActions from '../redux/MessagesRedux';
import { preparePhoneNumber } from '../helpers/string';

export function * getUser(api, action) {
  const response = yield call(api.getUser, action.id);

  if (response.ok) {
    yield put(UserActions.userSuccess(response.data));
  } else {
    yield put(UserActions.userFailure(response.data && response.data.title ? response.data.title : response.problem));
    yield put(MessagesActions.messagesShow({type: 'error', code: response.status, title: response.data && response.data.title ? response.data.title : response.problem}));
  }
}

export function * addUser(api, action) {
  let data = {...action.data};
  // формируем корректный номер телефона
  data.phone = preparePhoneNumber(data.phone);

  const response = yield call(api.addUser, data);

  if (response.ok) {
    yield put(UserActions.userSuccess(response.data));
    yield put(UsersActions.usersSuccess(null));
    yield put(MessagesActions.messagesShow({type: 'success', code: 'userAdd', title: 'Запись успешно создана'}));
  } else {
    yield put(UserActions.userFailure(response.data && response.data.title ? response.data.title : response.problem));
    yield put(MessagesActions.messagesShow({type: 'error', code: response.status, title: response.data && response.data.title ? response.data.title : response.problem}));
  }
}

export function * updateUser(api, action) {
  let data = {...action.data};
  // формируем корректный номер телефона
  if (data.phone) {
    data.phone = preparePhoneNumber(data.phone);
  }

  const response = yield call(api.editUser, data);

  if (response.ok) {
    yield put(UserActions.userSuccess(response.data));
    yield put(UsersActions.usersSuccess(null));
    yield put(MessagesActions.messagesShow({type: 'success', code: 'userUpdate', title: 'Запись успешно обновлена'}));
  } else {
    yield put(UserActions.userFailure(response.data && response.data.title ? response.data.title : response.problem));
    yield put(MessagesActions.messagesShow({type: 'error', code: response.status, title: response.data && response.data.title ? response.data.title : response.problem}));
  }
}

export function * deleteUser(api, action) {
  const response = yield call(api.deleteUser, action.id);

  if (response.ok) {
    yield put(UserActions.userSuccess(null));
    yield put(UsersActions.usersSuccess(null));
    yield put(MessagesActions.messagesShow({type: 'success', code: 'userDelete', title: 'Запись успешно удалена'}));
  } else {
    yield put(UserActions.userFailure(response.data && response.data.title ? response.data.title : response.problem));
    yield put(MessagesActions.messagesShow({type: 'error', code: response.status, title: response.data && response.data.title ? response.data.title : response.problem}));
  }
}
